import React, { useContext, useEffect, useState } from "react";
import { Container } from "components/Container";
import { useHistory } from "react-router";
import * as atoms from "./EditarPerfilStore";
import { useAtom } from "jotai";
import { useModalConfirmar } from "store/global";
import { ModalConfirmar } from "components/Modal/ModalConfirmar";
import {PerfilEditar} from "./perfil-editar";
import PerfilService from "services/PerfilService";
import { notification } from "antd";

const EditarPerfilPage = () => {
    let history = useHistory();
    const [loading, setLoading] = useState(false);
    const [perfil]=useAtom(atoms.perfilAtom);
    const cerrarModalConfirmacion = useModalConfirmar(state => state.cerrarModal);

    const onClickRetornarListarPerfiles = () => {

        history.push("/perfil");
    }
    const onClickBtnCancelarModal = () => {
        cerrarModalConfirmacion();
    }
    const onClickBtnConfirmarModal = async ()=>{
        try {
            setLoading(true);
            const _perfil= await PerfilService.actualizar(perfil);
            setLoading(false);
            cerrarModalConfirmacion();
            history.push("/perfil");
            
        } catch (error) {
            console.error(error);
            cerrarModalConfirmacion();
            notification.error({
                message:"Error",
                description:error.response.data.mensaje});
            
        }finally{
            setLoading(false);
        }

    }
    return(
        <Container titulo="Editar Perfil" onClickRetornar={onClickRetornarListarPerfiles}>
         <PerfilEditar/>
         <ModalConfirmar
                loading={loading}
                mensaje="¿Está seguro de actualizar el perfil? "
                onClickBtnCancelar={onClickBtnCancelarModal}
                onClickBtnConfirmar={onClickBtnConfirmarModal} />
        </Container>
    )

}
export default EditarPerfilPage;